<article class="profile-insight-card" [class.profile-insight-card--chart]="isChart" [class.profile-insight-card--metric]="insight.displayType === 'number'" [class.profile-insight-card--list]="insight.displayType === 'card_list'" [class.profile-insight-card--compact]="isCompact" [ngClass]="isCompact ? 'profile-insight-card--' + insight.displayType : ''">
  <span class="profile-insight-card__top"><span>{{ insight.eyebrow }}</span><i [class]="eyebrowIconClass" aria-hidden="true"></i></span>
  <h3 class="profile-insight-card__title">{{ insight.title }}</h3>
  <company-profile-insight-answer
    class="profile-insight-card__visual"
    [insight]="insight"
    [listLimit]="listLimit"
    [chartColours]="chartColours"
    [gaugeColour]="gaugeColour"
    [cardListHeaderColour]="cardListHeaderColour">
  </company-profile-insight-answer>
  <span class="profile-insight-card__foot">
    @if (showConfidence) {<span class="profile-insight-card__confidence"><i class="fas fa-circle" [style.color]="confidenceColour(insight.response?.confidence)" aria-hidden="true"></i> {{ confidenceLabel(insight.response?.confidence) }}</span>}
    @else {<span class="profile-insight-card__note">{{ footNote }}</span>}
    <button type="button" (click)="viewEvidence.emit(insight)" [attr.aria-label]="evidenceLabel + ' for ' + insight.title" aria-haspopup="dialog">{{ evidenceLabel }} <i class="fal fa-arrow-up-right" aria-hidden="true"></i></button>
  </span>
</article>
